/**
 * Legacy-Redirect: /commissions → /splits — Story 0.2 (v2-Relaunch)
 *
 * Kanonische Route der Provisions-Regeln ist seit dem v2-Relaunch /splits
 * (siehe layouts/nav.ts, LEGACY_PATH_REDIRECTS).
 */
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/commissions/')({
  beforeLoad: () => {
    throw redirect({ to: '/splits', replace: true })
  },
  component: () => null,
})
